export class ChangeDetailType {
  static get LicensePlate () {
    return 1
  }
  static get CustomerNumber () {
    return 2
  }

  static ChangeDetailTypeName (PayType) {
    let tmpType = parseInt(PayType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '變更車牌'
        break
      case 2:
        name = '變更抬頭'
        break
    }
    return name
  }
}
